import React from 'react'
import { Box, Chip } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'
import { MY_BUSINESS_ROUTES } from '@constants/routes'
import { dsColorNew } from '@palette'

import MappingAdminPage from '../_shared/MappingAdminPage'

export default function OfficeMappingPage({ embedded = false }) {
	return (
		<MappingAdminPage
			embedded={embedded}
			icon="location-dot"
			title={MY_BUSINESS_ROUTES.OFFICE_ADMIN_TITLE}
			subtitle={MY_BUSINESS_ROUTES.OFFICE_ADMIN_SUBTITLE}
			listEndpoint="/api/my-business/admin/office-mapping"
			rowKey="code"
			rowKeyParam="pms_office_code"
			pmsListKey="offices"
			valueField="ps_master_office_id"
			valueIsNumber
			psOptionLabel={(opt) => (
				<Box display="flex" alignItems="center" gap={0.75}>
					{opt.airport && (
						<Chip size="small" label={<IconSeeker icon="plane" sx={{ fontSize: 10 }}/>} variant="outlined"
						      sx={{ height: 18, fontSize: 11 }}/>
					)}
					<Box component="span" sx={{ fontWeight: 600 }}>
						{opt.iata || opt.country || '—'}
					</Box>
					<Box component="span" sx={{ color: dsColorNew.textMuted, fontWeight: 500 }}>
						{opt.name}
					</Box>
				</Box>
			)}
			pmsColumns={[
				{ label: 'PMS code', cell: (r) => (
					<Box sx={{ fontWeight: 700, color: dsColorNew.textTitle }}>{r.code}</Box>
				)},
				{ label: 'PMS name', cell: (r) => r.name },
			]}
			footerHint="Map each PMS office to the equivalent Price Seeker office. Unlocks per-office price comparison vs market in Module B."
		/>
	)
}
